export type PlayerSessionSummaryResponse = {
  totalSessions: number;
  totalPins: number;
  startDate: string;
};
